import { FormFieldType, FormGroupDirectionType, IFormGroupConfig } from '@shared/ui';

export const filterFormConfig: IFormGroupConfig = {
  type: FormFieldType.GROUP,
  direction: FormGroupDirectionType.ROW,
  fields: {
    iin: {
      type: FormFieldType.INPUT,
      label: 'ИИН:',
      placeholder: 'Введите свой иин',
      hideLabel: true,
    },
    fio: {
      type: FormFieldType.INPUT,
      label: 'ФИО:',
      placeholder: 'Введите ФИО',
      hideLabel: true,
    },
  },
};
